// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  projectId: __t.string(),
  format: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  quality: __t.string(),
  rangeStartUs: __t.f64(),
  rangeEndUs: __t.f64(),
  pool: __t.string(),
  includeAudio: __t.bool(),
  loudnessLufs: __t.f64(),
  encode: __t.string(),
  name: __t.string(),
};
